






















































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {getLog} from '@/ts/log/get-log';

export default {
    name: 'TheTableLog',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {
            eventData: String(),
            type: String(),
            user: String(),
            eventOptions: Array(),
            typeOptions: Array(),
        };
    },
    methods: {
        sort() {
            this.$store.dispatch('setLoadingOn');
            getLog(this.eventData, this.user, this.type).then(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    watch: {
        eventData(value) {
            this.$store.dispatch('setLoadingOn');
            getLog(this.eventData, this.user, this.type).then(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        type(value) {
            this.$store.dispatch('setLoadingOn');
            getLog(this.eventData, this.user, this.type).then(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    created() {
        this.eventOptions = [
            { value: '', text: 'Събитие' },
            { value: 'created', text: 'Създадени' },
            { value: 'updated', text: 'Обновени' },
            { value: 'deleted', text: 'Изтрити' },
        ];
        this.typeOptions = [
            { value: '', text: 'Тип' },
            { text: 'CartItem', value: 'CartItem'},
            { text: 'MenuCategory', value: 'MenuCategory' },
            { text: 'Order', value: 'Order' },
            { text: 'OrderItem', value: 'OrderItem' },
            { text: 'Product', value: 'Product' },
            { text: 'ProductVariation', value: 'ProductVariation' },
            { text: 'Restaurant', value: 'Restaurant' },
            { text: 'RestaurantTag', value: 'RestaurantTag' },
            { text: 'RestaurantTown', value: 'RestaurantTown' },
            { text: 'Town', value: 'Town' },
            { text: 'User', value: 'User' },
            { text: 'UserAddress', value: 'UserAddress' },
        ];
    },
};
